import { Table } from 'reactstrap';
import PercentageColumn from './columns/PercentageColumn';

const DiffTable = ({ metrics }) => {
  const { client, control, yy_diff, mm_diff, pp_diff } = metrics;
  const showY = Boolean(client.yy_average || control.yy_average);

  const avgKeyPpYy = showY ? 'yy_average' : 'pp_average';

  return (
    <Table className="mb-4 border" size="sm" striped borderless={true} bordered={true}>
      <thead>
        <tr>
          <th></th>
          <th>M/M</th>
          <th>% Diff</th>
          <th>{showY ? 'Y/Y' : 'P/P'}</th>
          <th>% Diff</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Campaign</td>
          <PercentageColumn value={client.mm_average} />
          <PercentageColumn value={mm_diff} />
          <PercentageColumn value={client[avgKeyPpYy]} />
          <PercentageColumn value={showY ? yy_diff : pp_diff} />
        </tr>
        <tr>
          <td>Control</td>
          <PercentageColumn value={control.mm_average} />
          <td></td>
          <PercentageColumn value={control[avgKeyPpYy]} />
          <td></td>
        </tr>
      </tbody>
    </Table>
  );
};

export default DiffTable;
